export default __webpack_public_path__ + "static/media/DefenceTonic.12f980c96ffd782f9b79ec1f5de09653.webp";